<div class="listing">
    @for (product of products; track product) {
        <div class="item-1 mb-5">
            <app-product-thumbnail [isBig]="false" [product]="product"> </app-product-thumbnail>
        </div>
    }
</div>
